/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('UserGradesCtrl', function(
    $scope,
    $location,
    $filter,
    identity,
    Term,
    user,
    sessions,
    terms,
    ErrorThrower
) {
    const errorManager         = new ErrorThrower;
    let current_term         = null;
    const now                  = moment().format('YYYY-MM-DD');
    $scope.isMe          = identity.login === user.login;
    $scope.student       = user;
    $scope.terms         = terms;
    $scope.popoverGrades = {templateUrl: 'partials/popoverGrades.html'};

    $scope.changeTerm = function(term_id) {
        $location.search({ term_id });
        return loadSessions(term_id);
    };

    $scope.get_activity_status = function(activity) {
        // si l'uv n'a pas été validée/invalidée, on ne précise pas de note éliminatoire
        if ((null === activity.student_mark) || (null === activity.validation)) { return ''; }

        // si on a une note éliminatoire,
        // on compare la note de l'étudiant avec cette note
        if ((null !== activity.activity_eliminate) && (-1 !== activity.activity_eliminate)) {
            if (activity.student_mark >= activity.activity_eliminate) { return 'Validée'; }
            if (activity.student_mark < activity.activity_eliminate) { return 'Non validée (éliminatoire)'; }
        // sinon on regarde juste s'il a la moyenne
        } else {
            if (activity.student_mark >= 10) { return 'Validée'; }
            if (activity.student_mark < 10) { return 'Non validée (moyenne)'; }
        }
    };

    $scope.eliminatory_style = function(activity) {
        if ((activity.activity_eliminate == null) ||
            (null === activity.validation) ||
            (-1 === activity.activity_eliminate) ||
            ('Non validée (éliminatoire)' !== $scope.get_activity_status(activity))) { return { }; }

        return { 'color': 'red' };
    };

    var loadSessions = function(term_id) {
        $scope.term_id = term_id;
        return Term
        .getMarks({
            term:  term_id,
            login: user.login}).$promise
        .then(grades_result => {
            $scope.grades = grades_result

            var session_result = []
            $scope.grades.forEach(item => {
                if(!session_result[item.session_id]) {
                    session_result[item.session_id] = {sum: 0, count: 0}
                }
                session_result[item.session_id].sum += item.student_mark * item.activity_coefficient
                session_result[item.session_id].count += item.activity_coefficient
            });

            for(let session_id in session_result) {
                if (session_result[session_id].count != 0) {
                    session_result[session_id].student_average = session_result[session_id].sum / session_result[session_id].count
                } else {
                    session_result[session_id].student_average = 0
                    console.log("the total coef for" +  session_result[session_id].id + "is 0, this is not supposed to happened. the error will be ignored")
                }
            }

            $scope.grades.forEach(item => {
                item.student_average = session_result[item.session_id].student_average;
            });

            return $scope.grades
        }).catch(api_error => errorManager.minor(api_error.statusText));
    };

    if ($location.search().term_id != null) {
        return $scope.changeTerm($location.search().term_id);
    } else {
        for (let term of Array.from(terms)) {
            if (((now > term.learning_start) && (now < term.learning_end)) || (null === current_term)) {
                current_term = term;
            }
        }
        return loadSessions(current_term.id);
    }
});
